var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-dropdown-item',{attrs:{"type":"link","loading":_vm.is.loading},nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }